import * as React from 'react';

import PropTypes from 'prop-types';
import type { LegacyContextType } from 'types/legacy-context-types';

import { deletePost } from 'bundles/discussions/actions/DropdownActions';
import { clearThreadsCache } from 'bundles/discussions/actions/ThreadsActions';
import DiscussionsModal from 'bundles/discussions/components/DiscussionsModal';
import ModerationReasonForm from 'bundles/discussions/components/ModerationReasonForm';

import _t from 'i18n!nls/discussions';

import 'css!./__styles__/Delete';

class Delete extends React.Component {
  static propTypes = {
    showReasons: PropTypes.bool.isRequired,
    showNotifyUser: PropTypes.bool,
    handleClose: PropTypes.func.isRequired,
    post: PropTypes.object.isRequired,
    onDeleteSuccess: PropTypes.func,
  };

  static contextTypes = {
    executeAction: PropTypes.func.isRequired,
  };

  declare context: LegacyContextType<typeof Delete.contextTypes>;

  static defaultProps = {
    showNotifyUser: true,
  };

  state = {
    selectedOption: '',
    showInputError: false,
    showServerError: false,
    dontNotify: false,
  };

  handleCancel = () => {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'handleClose' does not exist on type 'Rea... Remove this comment to see the full error message
    this.props.handleClose();
  };

  handleSubmitWithReason = (selectedOption: string, dontNotify: boolean) => {
    this.setState(
      {
        selectedOption,
        dontNotify,
      },
      this.handleSubmit
    );
  };

  handleSubmit = () => {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'showReasons' does not exist on type 'Rea... Remove this comment to see the full error message
    if (!this.props.showReasons || this.state.selectedOption) {
      this.context.executeAction(clearThreadsCache);
      this.context.executeAction(deletePost, {
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'post' does not exist on type 'Readonly<{... Remove this comment to see the full error message
        post: this.props.post,
        reason: this.state.selectedOption,
        handleSuccess: this.onDeleteSuccess,
        handleFailure: this.onDeleteError,
        dontNotify: this.state.dontNotify,
      });
    } else {
      this.setState({
        showInputError: true,
      });
    }
  };

  handleCloseModal = () => {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'handleClose' does not exist on type 'Rea... Remove this comment to see the full error message
    this.props.handleClose();
  };

  onDeleteError = (error: $TSFixMe) => {
    this.setState({
      showServerError: true,
    });
  };

  onDeleteSuccess = () => {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'handleClose' does not exist on type 'Rea... Remove this comment to see the full error message
    this.props.handleClose();
    // TODO(asrinivasan): Pass down view context and renavigate here
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'post' does not exist on type 'Readonly<{... Remove this comment to see the full error message
    if (this.props.post.type === 'question') {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'onDeleteSuccess' does not exist on type ... Remove this comment to see the full error message
      this.props.onDeleteSuccess(this.state.selectedOption);
    }
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'post' does not exist on type 'Readonly<{... Remove this comment to see the full error message
    if (this.props.post.type === 'comment' || this.props.post.type === 'answer') {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'onDeleteSuccess' does not exist on type ... Remove this comment to see the full error message
      this.props.onDeleteSuccess?.();
    }
  };

  toggleNotify = () => {
    this.setState((prevState) => {
      return {
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'dontNotify' does not exist on type 'Read... Remove this comment to see the full error message
        dontNotify: !prevState.dontNotify,
      };
    });
  };

  render() {
    const modal = (
      <DiscussionsModal handleClose={this.handleCloseModal} modalName={_t('Delete Post')}>
        {/* @ts-expect-error ts-migrate(2339) FIXME: Property 'showReasons' does not exist on type 'Rea... Remove this comment to see the full error message */}
        {this.props.showReasons ? (
          <ModerationReasonForm
            handleCancel={this.handleCancel}
            handleSuccess={this.handleSubmitWithReason}
            title={_t('Delete Post')}
            subtitle={_t('Why do you want to delete this?')}
            submitButtonText={_t('Delete')}
            /* @ts-expect-error ts-migrate(2339) FIXME: Property 'showNotifyUser' does not exist on type '... Remove this comment to see the full error message */
            showNotifyUser={this.props.showNotifyUser}
          />
        ) : (
          <React.Fragment>
            <h2 className="c-modal-title subtitle display-1-text">{_t('Delete Post')}</h2>

            <div className="c-delete-warning">{_t('Are you sure you want to delete this post?')}</div>

            <div>
              <div role="alert" className="c-error-text c-modal-error-message">
                {this.state.showServerError && _t('Error deleting post; please try again or reload the page')}
              </div>

              <div className="horizontal-box align-items-right">
                <button className="secondary" type="button" onClick={this.handleCancel}>
                  {_t('Cancel')}
                </button>
                &nbsp;&nbsp;
                <button className="primary" type="submit" onClick={this.handleSubmit}>
                  {_t('Delete')}
                </button>
              </div>
            </div>
          </React.Fragment>
        )}
      </DiscussionsModal>
    );

    return <div className="rc-Delete">{modal}</div>;
  }
}

export default Delete;
